var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchWhiteShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ndi10imwxa",
    width: "187.5%",
    height: "187.5%",
    x: "-43.8%",
    y: "-43.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ndi10imwxa)",
    transform: "translate(-271 -29) translate(271 29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C5 7.467 7.467 5 10.5 5c3.032 0 5.5 2.467 5.5 5.5S13.532 16 10.5 16C7.466 16 5 13.533 5 10.5zm16 8.924l-4.378-4.378c.932-1.257 1.485-2.811 1.485-4.493C18.107 6.388 14.718 3 10.553 3 6.388 3 3 6.388 3 10.553s3.388 7.554 7.553 7.554c1.681 0 3.236-.553 4.492-1.485L19.424 21 21 19.424z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchWhiteShadow);
export default __webpack_public_path__ + "static/media/ic_search_white_shadow.eebc04cbe8237cfbb582579ab90ade13.svg";
export { ForwardRef as ReactComponent };